export const getFilteredOptions = (options, searchValue) => {
  if (!searchValue) return [];

  const allMatches = Object.keys(options)
    .filter((key) => key.toLowerCase().includes(searchValue.toLowerCase()))
    .map((key) => ({ name: key, ...options[key] }));

  const talenti = allMatches.filter((o) => o.company_name === 'Talenti');
  const others = allMatches.filter((o) => o.company_name !== 'Talenti');

  const byCompany = {};
  others.forEach((o) => {
    if (!byCompany[o.company_name]) byCompany[o.company_name] = [];
    byCompany[o.company_name].push(o);
  });

  // round-robin בין חברות אחרות
  const diverse = [];
  const queues = Object.values(byCompany);
  let hasMore = true;
  let round = 0;
  while (hasMore) {
    hasMore = false;
    for (let qi = 0; qi < queues.length; qi++) {
      if (round < queues[qi].length) {
        diverse.push(queues[qi][round]);
        hasMore = true;
      }
    }
    round++;
  }

  // Talenti מקבלת מקסימום 3 מקומות, לפחות 2 שמורים לחברות אחרות
  const talentiSlots = others.length > 0 ? Math.min(talenti.length, 3) : 5;
  const othersSlots = 5 - talentiSlots;

  return [
    ...talenti.slice(0, talentiSlots),
    ...diverse.slice(0, othersSlots),
  ];
};
